export const roundToXDigits = (value: number, digits: number) => {
    value = value * Math.pow(10, digits);
    value = Math.round(value);
    value = value / Math.pow(10, digits);
    return value;
}

export const Timeout = (time: number) => {
    let controller = new AbortController();
    setTimeout(() => controller.abort(), time * 10000);
    return controller;
};

export const convertNumberToCurrencyFormat = (value: number) => {
    return value.toLocaleString('vi-VN')
  }

export const sendTelegramMessage = async (chatId: string, token: string, message: string) => {
const url = `https://api.telegram.org/bot${token}/sendMessage?chat_id=${chatId}&text=${message ?? '-'}`
// const controller = new AbortController()
// const timeoutId = setTimeout(() => controller.abort(), 15000)
await fetch(url, {
    method: 'POST',
    signal: AbortSignal.timeout(15000)
})
}